<template>
  <eg-radio-checkbox-input type="radio" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import EgRadioCheckboxInput from "./eg_radio_checkbox_input.vue";
export default {
  name: "EgRadioInput",
  components: {
    EgRadioCheckboxInput,
  },
};
</script>
